<template>
  <el-form
      label-position="top"
      ref="form"
      :model="form"
      :rules="rules"
      class="form"
      size="mini">
    <el-row :span="24" :gutter="20">
      <el-col :span="4">
        <el-form-item label="Received Date" prop="receivedDate">
          <el-date-picker
              style="width:100%"
              v-model="form.receivedDate"
              :clearable='false'
              format="d MMM yy"
              value-format="MM-dd-yyyy"
              type="date"
              placeholder="Select Date">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="Sales Clearing Account" prop="salesClearingAccount">
          <el-select
              no-data-text="no date"
              placeholder="Sales Clearing Account"
              class="select"
              v-model="form.salesClearingAccount"
          >
            <el-option
                v-for="item in salesClearingAccountList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="Amount Received" prop="chequeRef">
          <el-input placeholder="+ Amount" v-model="form.amountReceived"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="Balance to Received" prop="balanceToReceive">
          <el-input placeholder="Balance to Received" v-model="form.balanceToReceive"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="Cheque / Ref #" prop="chequeRef">
          <el-input placeholder="Cheque Vaucher/Ref #" v-model="form.chequeRef">
          </el-input>
        </el-form-item>
      </el-col>
<!--      <el-col :span="4">-->
<!--        <el-form-item label="Received By" prop="receivedBy">-->
<!--          <el-select-->
<!--              no-data-text="no date"-->
<!--              placeholder="Received By"-->
<!--              class="select"-->
<!--              v-model="form.receivedBy"-->
<!--          >-->
<!--            <el-option-->
<!--                v-for="item in receivedByList"-->
<!--                :key="item.id"-->
<!--                :label="item.name"-->
<!--                :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: "ClearingAccountMethod",
  data() {
    return {
      form: {
        receivedDate: null,
        salesClearingAccount: null,
        amountReceived: null,
        balanceToReceive: null,
        chequeRef: null,
        // receivedBy: null,
      }
    }
  },
  props: {
    salesClearingAccountList: {
      type: Array,
      default: () => ([])
    },
    // receivedByList: {
    //   type: Array,
    //   default: () => ([])
    // }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input {
  width: 100%;
}
</style>